/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useState, lazy, Suspense } from 'react';
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import {
  generateYtThumbnail, imagePath,
  generateYtVideoLink
} from '../Utils/helpers';
import { Image } from "react-bootstrap";
import { Loader } from './Loader';
import styled from 'styled-components'

const ReactPlayerWrapper = lazy(() => import('./ReactPlayerWrapper'));


const VideoCarousel = ({ videoIdArray, ...props }) => {

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
      slidesToSlide: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };


  const responsive1 = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  const [isOpenSingleVideo, setIsOpenSingleVideo] = useState(false)
  const [isOpenVideoList, setIsOpenVideoList] = useState(false)
  const [currentVideoId, setCurrentVideoId] = useState('')
  const [mouseActivity, setMouseActivity] = useState(['', '', ''])
  const [isLoading, setisLoading] = useState(['', '', ''])


  const [videoItemsLength, setVideoItemsLength] = useState()

  //const [videoItemsLength, setVideoItemsLength] = useState(videoIdArray.length)

  const handleThumbnailClick = (e, id) => {
    e.preventDefault()
    setIsOpenSingleVideo(true)
    setCurrentVideoId(id)
  }

  const latestLoadingUpdate = (currentState) => {
    setisLoading(currentState)
  }



  const handleCustomArrowClick = (e, arrowType) => {
    e.preventDefault()
    const domInbuiltArrowName = arrowType === 'Next' ? 'right' : 'left'
    const inbuiltArrow = document.querySelectorAll('.react-multiple-carousel__arrow.react-multiple-carousel__arrow--' + domInbuiltArrowName)
    console.log('CUstom: ', inbuiltArrow)

    if (inbuiltArrow && inbuiltArrow.length === 1) {
      inbuiltArrow[0].click()
    }
  }
  const handleOverlayCloseClick = (e) => {
    setIsOpenSingleVideo(false)
    setCurrentVideoId('')
  }


  return (
    <StyleWrapper>
      <div className="gallery-section-container pt-1" style={{ backgroundColor: '#FFF' }}>

        <div className="top-section" >
          <div className="table-title broker-videos-title" style={{ marginLeft: 'auto', marginRight: 'auto' }}>

            {props.subheading &&
              <h2 >{props.subheading}</h2>}

            {props.title && <h4 style={{ textAlign: 'center', color: '#72369D' }}>{props.title}</h4>}
          </div>

          <div className="custom-arrows-div">

            <div className="slider-custom-arrows arrow-left"
              onClick={(e) => handleCustomArrowClick(e, 'Previous')}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
                <path d="M0.00292969 7.44209L7.18964 14.6288L8.8805 12.9379L3.37985 7.4373L8.8805 1.93666L7.18964 0.255371L0.00292969 7.44209Z" fill="#999999" />
              </svg>
            </div>
            <div className="slider-custom-arrows arrow-right"
              onClick={(e) => handleCustomArrowClick(e, 'Next')}
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
              <path d="M0.00292969 7.44209L7.18964 14.6288L8.8805 12.9379L3.37985 7.4373L8.8805 1.93666L7.18964 0.255371L0.00292969 7.44209Z" fill="#999999" />
            </svg>
            </div>

          </div>


        </div>

        <div className='video-grid'>

          <Carousel
            swipeable={true}
            draggable={true}
            showDots={false}
            responsive={responsive}
            // ssr={true} // means to render carousel on server-side.
            // infinite={videoItemsLength !== videoIdArray.length ? false : true}
            infinite={false}
            centerMode={false}
            autoPlaySpeed={5000}
            keyBoardControl={true}
            autoPlay={true}
            customTransition="all .5s ease"
            containerClass="carousel-container"
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
          >
            {
              videoIdArray.slice(0, videoItemsLength).map((item, index) => (
                <>
                  <div
                    className="thumbnail-container"
                  >
                    {/* {index === videoItemsLength - 1 && videoItemsLength !== videoIdArray.length ?
                                            <div className="view-more-card thumbnail-image"
                                                onClick={e => setVideoItemsLength(videoIdArray.length)}
                                            >
                                                View More
                                            </div> : */}
                    <div className={
                      `image-wrapper ${item.id === currentVideoId ? 'now-playing' : ''
                      }`
                    }>
                      <Image
                        className="thumbnail-image"
                        src={generateYtThumbnail(item.id)}
                        onClick={(e) => {
                          handleThumbnailClick(e, item.id)
                        }}
                        draggable="false"
                        width="320"
                        height="220"
                        alt=""
                        srcSet={`${generateYtThumbnail(item.id)} 1650w, ${generateYtThumbnail(item.id)} 300w, ${generateYtThumbnail(item.id)} 768w,`}
                        sizes="(max-width:1650px) 100vw, 1650px"
                      // style={{height:"auto"}}
                      ></Image>
                    </div>

                    {/* } */}
                  </div>
                </>
              ))
            }
          </Carousel>
        </div>

        {isOpenSingleVideo &&
          <div
            className={`react-video-overlay ${isLoading ? 'loader-present' : ''}`}
            id="draggable" >
            <div id="draggableHeader" title="Hold and drag to move this window">
              <button title="Close" className="react-video-overlay--close-btn"
                onClick={(e) => handleOverlayCloseClick(e)}
              ><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABmJLR0QA/wD/AP+gvaeTAAAA3UlEQVRIie2VSw6CQBBEwRMorv3g/c8hxI1bNArhJM+Fk0BkpqeAmGhCrat5VM9Md5Is+ksBG6AE7sBB8B+ctwQyFbIGLnRqgZPh3wPPnv8KbBVQwVC1L5lLUnv8RQySAjdP4QBmQHDfSGOwz1b01QK54Am22teSxkgWStIARwkiJpuXZAasBfJJkBEwCbKa9Red7BsW08jWff18pp8T9mNssK9+dDYqSdQHayfDHkEN+giqEEZQGYMIMHuoumLfmgi2AtgBj55fWxOuOOO9LipfkkCyCjijLr5FP6cXh7JvcWVu5G0AAAAASUVORK5CYII=" /></button>
            </div>
            <Suspense fallback={<Loader />}>
              <ReactPlayerWrapper
                width="auto"
                height="200"
                url={generateYtVideoLink(currentVideoId)}
                latestLoadingUpdate={latestLoadingUpdate}
              // deviceType={deviceType}
              />
            </Suspense>
          </div>
        }


      </div>
    </StyleWrapper>
  );
}


const StyleWrapper = styled.div`
.gallery-section-container .thumbnail-container {
  background-color: transparent !important;
  border: 10px solid transparent!important;
  padding-left: 0;
  padding-right: 0;
}
 
.gallery-section-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding: 80px;
  padding-bottom:0px!important
}
.video-grid{
  border: 2px solid #311540;
  padding: 4rem 0 1rem;
  border-radius: 30px;
}

.table-title h2{
  color: var(--primary-purple-1, #461E5C);
  text-align: center;
  font-family: var(--font-family-Typeface-Taglines);
  font-weight: 700;
}
.table-title h4{
  font-weight: 700;
}
.table-title{
 background-color:white;
 margin-top:2rem;
 border-radius:40px;
 padding:8px 20px 5px 20px;
}
.top-section {
  display: flex;
  position: relative;
}
@media (min-width: 320px) and (max-width: 767px) {
  .gallery-section-container .thumbnail-container {
    background-color: transparent!important;
    border: 20px solid transparent!important;
    padding-left: 0;
    padding-right: 0;
  }
  .gallery-section-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    padding: 15px!important;
    padding-bottom:50px!important
  }
  .video-grid{
    border: none;
    padding: 0;
  }
  .table-title{
    margin-top:0rem!important;
    margin-bottom:-1rem!important;
  }
  .custom-arrows-div{
    display: flex !Important;
    position: absolute;
    top: 17rem;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 1;
    cursor: pointer;
    gap: 1rem;
  }
  .arrow-right{
    transform: rotate(180deg);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .gallery-section-container .thumbnail-container {
    background-color: transparent!important;
    border: 20px solid transparent!important;
    padding-left: 0;
    padding-right: 0;
  }
  .gallery-section-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
   // gap: 1rem;
    padding: 15px!important;
    padding-bottom:50px!important
  }
}
@media (min-width: 768px) {
  .table-title{
    margin-top:-3rem!important;
    transform: translateY(4.25rem);
   }
}
.top-section::before {
  content: "";
position: absolute;
left: 0;
bottom: 0;
height: 1px;
width: 50%;
opacity: 0.5;
background-color:#FFFF!important;
}

.custom-arrows-div{
  display: none;
}

.react-player-container {
  width: 100%;
  position: relative;
}

.react-player-class-container {
  aspect-ratio: 16/9;
}
@supports not (aspect-ratio: 16/9) {
  .react-player-class-container {
    width: 100% !important;
    height: 50vh !important;
  }
}

.react-player-container > * {
  max-width: 90%;
  margin: 0 auto;
}

.video-grid {
  // display: grid;
  // justify-content: center;
  // grid-auto-columns: 50px minmax(200px, 100vw) 50px ;
  align-content: center;
  align-items: center;
}

.middle-section {
  display: flex;
  flex-direction: column;
}


.react-multiple-carousel__arrow.react-multiple-carousel__arrow--right,
.react-multiple-carousel__arrow.react-multiple-carousel__arrow--left {
  display: none;
}
.slider-custom-arrows {
  align-self: center;
  justify-self: center;
  border-radius: 100%;
  font-family: 'Roboto-Bold';
  background: #fff;
  color: #999;
  width: fit-content;
  padding: 1rem 1.25rem;
  line-height: 1;
  cursor: pointer;
  border: 1px solid #FFAD03;
}
.slider-custom-arrows:hover{
  border-radius: 50%;
  color: #fff !important;
  background: #FFAD03;
  box-shadow: 0px 20px 30px 0px rgba(249, 133, 35, 0.25);
}
.slider-custom-arrows:hover>svg {
  color: #fff !important;
}
.next-btn {
  position: absolute;
  transition: all .5s;
  border-radius: 35px;
  z-index: 1000;
  border: 0;
  background: yellow;
  min-width: 43px;
  min-height: 43px;
  right: 0;
  cursor: pointer;
}

.thumbnail-image {
  width: 100%;
  cursor: pointer;
  border-radius: 20px
}

.thumbnail-image:hover {
  box-shadow: 0px 0px 8px #1e4383;
}

button.gallery-view-more-btn.btn-primary{
  font-size: 18px;
  font-family: 'Roboto-Medium';
  border-top-left-radius: 15px ;
  border-top-right-radius: 0 ;
  border-bottom-left-radius: 0 ;
  border-top: 1px solid #083f88 !important;
  border-left: 1px solid #083f88 !important;
  width: fit-content;
  align-self: flex-end;
  padding: 2px 10px;
  background-color: #083f88;
  color: #fff;
  text-shadow: 0 0 3px #fff;
  /* text-shadow: -1px 0px 2px #083f88; */
  /* -webkit-box-shadow: inset 0px 0px 11px 2px #083f88; 
  box-shadow: inset 0px 0px 11px 2px #083f88; */
  position: absolute;
  bottom: 4%;
}
button.gallery-view-more-btn.btn-primary:hover{
  /* -webkit-box-shadow: inset 0px 0px 11px 6px #083f88; 
  box-shadow: inset 0px 0px 11px 6px #083f88; */
  box-shadow: 0 0 4px 2px #2ba8e0;
  transition: all 0.2s linear;
}
button.gallery-view-more-btn.btn-primary:active,
button.gallery-view-more-btn.btn-primary:focus {
  outline: none;
  box-shadow: 0 0 0 1px #083f88;
}

.view-more-card {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #808081;
  position: absolute;
  width: 100%;
  height: 85%;
  font-family: 'Roboto-Bold';
  background-color: #eaebec;
  line-height: 1;
}

.custom-right-arrow {
  position: absolute;
  right: 0;
  bottom: -5%;
  z-index: 3;
}

.react-video-overlay {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  width: 45vw;
  z-index: 10;
  cursor: move;
}

.react-video-overlay .react-player-class-container {
  border: 2px solid #2ba8e0;
  border-top: 0
}

.react-video-overlay--close-btn {
  content: '';
  color: #fff;
  font-family: 'Roboto-Bold';
  background: transparent;
  border-color: transparent;
  box-sizing: border-box;
  border-radius: 0;
  font-size: 1.5rem;
  margin-left: auto;
  line-height: 1;
  inset: -10px -10px auto auto;
  z-index: 10;

}

.react-video-overlay--close-btn:hover{
  text-shadow: 0 0 3px #0277ad;
}

#draggableHeader {
  display: flex;
  width: 100%;
  background: -moz-linear-gradient(left, #034390 0%, #fff 50%, #034390 100%);
  background: -webkit-linear-gradient(left, #034390 0%, #fff 50%, #034390 100%);
  background: linear-gradient(to right, #034390 0%, #fff 50%, #034390 100%);
  border: 2px solid #2ba8e0;
  border-bottom: 0;
  cursor: move;
}

.react-video-overlay.loader-present{
  background-color: #fff;
  opacity: 0.8;
  transition: all 0.2s linear;
}

@media (min-width: 768px) and (max-width: 1025px) {
  .react-video-overlay {
      width: 65vw;
  }
  @supports not (aspect-ratio: 16/9) {
      .react-player-class-container {
          width: 100% !important;
          height: 42vh !important;
      }
  }
}
@media (max-width: 768px) {
  .react-video-overlay {
      width: 90vw;
  }
  @supports not (aspect-ratio: 16/9) {
      .react-player-class-container {
          width: 100% !important;
          height: 42vh !important;
      }
  }
  @supports not (aspect-ratio: 2/2) {
      .react-player-class-container {
          width: 100% !important;
          height: 42vh !important;
      }
  }
}
@media (min-width: 1000px) {

  .table-title.broker-videos-title {
    transform: translateY(4.25rem);
      font-size: clamp(30px, calc(30px + 2vw) , 45px);
      line-height: 1.5;
  }
}
@media (max-width: 575px) {
  .custom-arrows-div{
    top: 21rem;
  }
  .thumbnail-image{
    height: 200px !important;
  }

  .broker-videos-title h3{
      font-size: 20px;
      text-align:center;
  }

  .broker-videos-title h4{
    font-size: 20px;
}

  .gallery-section-container .react-multiple-carousel__arrow{
      opacity: 0.8;
  }

}

@media only screen and (max-width: 399px) {
  button.gallery-view-more-btn.btn-primary {
      font-size: 12px;
      padding: 2px 6px;
  }

  .react-player-class-container {
      aspect-ratio: 2/2;
  }

  @supports not (aspect-ratio: 2/2) {
      .react-player-class-container {
          width: 100% !important;
          height: 42vh !important;
      }
  }
}

.react-video-modal .modal-header {
  background-color: transparent;
  padding-bottom: 5px;
  padding-top: 5px;
  border-bottom: none;
  background: linear-gradient(90deg, rgba(43,57,140,1) 0%, rgba(11,79,155,1) 35%, rgba(7,114,183,1) 100%);
  border-color: transparent;
}
.react-video-modal .modal-title {
  color: #fff;
}
.react-video-modal .modal-header .close{
  color: white;
  opacity: 1;
}
.react-video-modal .modal-content {
  box-shadow: inset 0em 0em 7px #1e4383;
  border: 0;
  gap: 1rem;
}

.react-multiple-carousel__arrow--left {
  left: calc(2% + 1px);
}
.react-multiple-carousel__arrow--right {
  right: calc(2% + 1px);
}

.video-player-body > * {
  width: fit-content;
  margin: 0 auto;
}

.fallback-react-player {
  width: 2rem;
  height: 2rem;
  position: absolute;
  align-items: center;
  left: 50%;
  top: 50%;
  background: black;
  opacity: 0.5;
}

.error-div {
  font-family: "Roboto-Medium";
  color: #083f88 !important;
  position: absolute;
  align-items: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

@media(min-width: 575px) {

  .video-player-body.modal-body {
      padding-top: 0;
  }
}
@media(max-width: 575px) {
  .react-video-modal .modal-title {
      font-size: 18px;
  }
}

`

export default VideoCarousel
